<!-- Floating Enquiry Button -->
<button class="fab-btn fab-enquiry" (click)="openEnquiryModal()" title="Enquire Now">
  <i class="bi bi-chat-dots-fill"></i>
</button>

<!-- Enquiry Modal -->
@if (showEnquiryModal) {
<div class="enquiry-modal-backdrop" (click)="closeEnquiryModal()">
  <div class="enquiry-modal" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeEnquiryModal()">
      <i class="bi bi-x-lg"></i>
    </button>
    <div class="modal-header-section">
      <div class="modal-icon">
        <i class="bi bi-lightning-charge-fill"></i>
      </div>
      <h3 class="modal-title">Enquire Now</h3>
      <p class="modal-subtitle">Fill in your details and we'll get back to you</p>
    </div>
    <form (ngSubmit)="submitEnquiry()" class="modal-form">
      <div class="modal-form-group">
        <label for="fab-name">Name <span class="required">*</span></label>
        <input type="text" id="fab-name" [(ngModel)]="enquiryForm.name" name="name" placeholder="Your full name"
          required>
      </div>
      <div class="modal-form-group">
        <label for="fab-phone">Phone Number <span class="required">*</span></label>
        <input type="tel" id="fab-phone" [(ngModel)]="enquiryForm.phone" name="phone"
          placeholder="Your phone number" required pattern="[0-9]{10}" maxlength="10" minlength="10" 
          (keypress)="onlyNumbers($event)" inputmode="numeric">
      </div>
      <div class="modal-form-group">
        <label for="fab-email">Email <span class="required">*</span></label>
        <input type="email" id="fab-email" [(ngModel)]="enquiryForm.email" name="email"
          placeholder="Your email address" required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}">
      </div>
      <div class="modal-form-row">
        <div class="modal-form-group">
          <label for="fab-city">City</label>
          <input type="text" id="fab-city" [(ngModel)]="enquiryForm.city" name="city" placeholder="City">
        </div>
        <div class="modal-form-group">
          <label for="fab-state">State</label>
          <input type="text" id="fab-state" [(ngModel)]="enquiryForm.state" name="state" placeholder="State">
        </div>
      </div>
      <div class="modal-form-group">
        <label for="fab-description">Description</label>
        <textarea id="fab-description" [(ngModel)]="enquiryForm.description" name="description"
          placeholder="Tell us what you're looking for..." rows="3"></textarea>
      </div>
      <button type="submit" class="modal-btn-submit">
        <span>Submit Enquiry</span>
        <i class="bi bi-send"></i>
      </button>
      <p class="text-center mt-3 mb-0" style="font-size: 0.85rem; color: #6b7280;">
        <i class="bi bi-info-circle"></i> Our team will contact you within 24–48 hours after receiving your enquiry.
      </p>
    </form>
  </div>
</div>
}
